<document-lines-editor
  #lineGrid
  [title]="'Doc::Deposits' | abpLocalization"
  [columnDefs]="columnDefs"
  [rows]="lines"
  [onCellValueChanged]="onCellValueChanged"
  [getDataPath]="getDataPath"
  [getContextMenuItems]="getContextMenuItems"
  [rowClassRules]="rowClassRules"
  [isDialogBox]="true"
  [fillRemainingHeight]="false"
  [domLayout]="'autoHeight'"
  gridStateKey="deliveryNoteDepositGrid"
>
</document-lines-editor>
